import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { colors } from '../../theme'

export const PrincipalDiv = styled.div`
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  background-color: ${colors.surface};
  border-radius: 24px;
  padding: 20px;
`

export const H3 = styled.h3`
  font-weight: 500;
  font-size: 15px;
  line-height: 140%;
  letter-spacing: 0.2px;
  color: ${colors.primaryText};
  margin-bottom: 15px;
`

export const ContainerDownload = styled.div`
  width: 20%;
`

export const Span = styled.span`
  display: flex;
  font-size: 12px;
  padding: 10px;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  width: 50vw;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  border-radius: 12px;
`

export const ButtonDownload = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px 30px;
  border-radius: 12px;
  background-color: ${colors.accentBg};
  color: ${colors.white};
  border: none;
  text-decoration: none;
  cursor: pointer;
`

export const H4 = styled.h4`
  font-weight: 400;
  font-size: 15px;
  line-height: 140%;
  letter-spacing: 0.2px;
  color: ${colors.primaryText};
  margin: 40px 0 25px 0;
  width: 30%;
`

export const ImportFile = styled.label`
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  background-color: ${colors.grey300};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 8px 20px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  width: 250px;
  height: 40px;
`

export const Input = styled.input.attrs({ type: 'file' })`
  display: none;
`

export const ButtonSubmit = styled.button`
  background-color: ${colors.accentBg};
  width: 200px;
  height: 40px;
  font-size: 13px;
  color: ${colors.white};
  border: none;
  border-radius: 12px;
  margin-top: 20px;
  cursor: pointer;
`

export const File = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 14px;
  color: ${colors.primaryText};
  font-weight: 700;
  font-size: 14px;
  height: 40px;
  width: 400px;
  box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.28);
  margin-top: 10px;
  border: solid 1px ${colors.grey200};
  background-color: ${colors.surface};
  border: none;
  cursor: pointer;
`

export const FileIconStyles = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${colors.primaryText};
  font-weight: 700;
  font-size: 14px;
  margin-left: 10px;
`
